export const locale = 'en-AU';
export const currencyDefaults = { style: 'currency', currency: 'AUD' };
